import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'

import { truncateText } from 'app/utils/text'
import { TickIcon, FileIcon } from 'app/components/icons'
import { setConfirmUploadedData, setUserDidConfirmTheUploadedData } from 'app/redux/messages/messages.actions'
import './UploadConfirm.scss'

const getUploadConfirmData = ({ messagesData }) => messagesData.messages.confirmUploadedData
const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts

function UploadConfirm() {
  const dispatch = useDispatch()
  const confirmUploadedData = useSelector(getUploadConfirmData)
  const texts = useSelector(getTexts)

  const fileType = confirmUploadedData.type
  const fileName = confirmUploadedData.name.split('.')?.[0]

  const fileExtension = confirmUploadedData.file.type.split('/')?.[1]
  const isFileImage = fileType === 'image'

  const renderPreviewImage = () => {
    if (isFileImage) {
      return (
        <img src={confirmUploadedData?.fileData} className="file_uploaded_successfully_file_preview_image" alt="" />
      )
    }

    return <FileIcon color="#868686" className="file_uploaded_successfully_file_preview_file_type_img" />
  }

  function handleConfirm() {
    dispatch(setUserDidConfirmTheUploadedData(confirmUploadedData))
  }

  function handleCancel() {
    dispatch(setConfirmUploadedData(null))
  }

  return (
    <div
      className={clsx(
        'upload_confirm_container',
        confirmUploadedData ? 'show_confirm_uploaded_file' : 'hide_confirm_uploaded_file',
      )}
    >
      <div className="file_uploaded_successfully_header_wrapper">
        <div className="file_uploaded_successfully_header_icon_wrapper">
          <TickIcon className="file_uploaded_successfully_header_icon" />
        </div>
        <p className="file_uploaded_successfully_header_title">{texts.confirmSendFile}</p>
      </div>

      <div className="file_uploaded_successfully_body_wrapper">
        <div data-isimage={isFileImage} className="file_uploaded_successfully_file_preview_wrapper">
          {!isFileImage && <span className="file_uploaded_successfully_extension">{`.${fileExtension}`}</span>}
          {renderPreviewImage()}
        </div>

        <div className="file_uploaded_successfully_body_data">
          <p className="file_uploaded_successfully_filename">{truncateText(fileName, 120)}</p>
          <div className="file_uploaded_successfully_actions_wrapper">
            <button
              className="file_uploaded_action_btn file_uploaded_successfully_confirm_action"
              onClick={handleConfirm}
            >
              {texts.uploadConfirm}
            </button>
            <button
              className="file_uploaded_action_btn file_uploaded_successfully_cancel_action"
              onClick={handleCancel}
            >
              {texts.uploadCancel}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UploadConfirm
